/*
* This code is the intellectual property of Bulb Inc. and other software publishers;
* it may not be altered, copied or disclosed without prior written approval.
* Copyright 2021, Bulb Inc.  For more information, please email contact@hellobulb.com.
*                _
*  _            | | _
* | |         _ | || |
* | |__   _  | || || |__
* | '_ \ | | | || || '_ \
* | (_) || |_| || || (_) |
*  \___/  \___/ |_| \___/
*/

/**
 * Utility class for CKEditor.
 */
export default class CKEditorUtils {

  /**
   * Allowed attributes for the figure tag.
   * @private
   * @static
   * @type {string[]}
   */
  private static ALLOWED_ATTRIBUTES: string[] = ['class', 'bulb-block-id', 'bulb-id', 'asset-type', 'style', 'effect',
    'bulb-block-version'];

  /**
   * Classes to save for the figure tag.
   * @private
   * @static
   * @type {string[]}
   * @memberof CKEditorUtils
   * @description These are the classes that we want to save for the figure tag.
   * We are going to remove all other classes.
   * This is because we want to ensure that we are only saving the classes that are
   * necessary for the editor to render the content correctly.
   */
  private static CLASSES_TO_SAVE: string[] = ['ck', 'block-alignment-left', 'block-alignment-right',
    'block-alignment-center', 'image-alignment-left', 'image-alignment-right', 'block-resized', 'image', 'video',
    'audio', 'embed', 'attached-file', 'image-carousel', 'table', 'transcoder'];

  /**
   * To generate object id.
   * @returns {string} Object id.
   */
  static mongoObjectId(): string {
    const timestamp = ((new Date().getTime() / 1000) | 0).toString(16);
    return timestamp + 'xxxxxxxxxxxxxxxx'.replace(/x/g, () => ((Math.random() * 16) | 0).toString(16)).toLowerCase();
  }

  /**
   * Handle the sanitization of the data within the editor before saving it.
   *
   * @param $data Data from the editor instance, i.e the content of the editor.
   * @returns {void}
   */
  static handleSanitization($data: any): void {
    const figureTags: any = $data.find('figure');

    if (figureTags && figureTags.length > 0) {
      Array.from(figureTags).forEach((figureTag) => {
        const currentWidget = $(figureTag);
        // Ensure figureTag is an HTMLElement
        const htmlFigureTag = figureTag as HTMLElement;
        // For each figure we need to remove all attributes except for bulb-block-id & class, this is
        // EXCEPT for images.
        if (htmlFigureTag.attributes && htmlFigureTag.attributes.length > 0) {
          Array.from(htmlFigureTag.attributes).forEach((currentAttribute) => {
            if (!CKEditorUtils.ALLOWED_ATTRIBUTES.includes(currentAttribute.name)) {
              htmlFigureTag.removeAttribute(currentAttribute.name);
            }
          });
        }

        // Then remove all classes that are assigned by CKEditor.
        const figureClasses = currentWidget.attr('class').split(' ');
        const newClassArray = figureClasses.filter(
          (className) => CKEditorUtils.CLASSES_TO_SAVE.includes(className),
        ).join(' ');
        if (newClassArray.length === 0) {
          currentWidget.remove();
        } else {
          currentWidget.attr('class', newClassArray);
        }

        // Finally, we need to empty all of the children except for the figcaption, which is second child.
        // However, if it is a media embed, then we want to just save the first-child of the parent figure.
        // Also, if it is an image, we are going to leave the children.
        // we are commenting this code for now for BULBAPP-6819 fix. we need to check
        // it's impact before removing permanently.
        // if (currentWidget.hasClass('embed')) {
        //   currentWidget.find(':first-child').find(':first-child').remove();
        // }
      });
    }
  }
}
